interface IdentityDetails {
    email?: string;
    id?: string | number;
    firstname?: string;
    lastname?: string;
}

type CommandsWithParams = {
    "identify": IdentityDetails,
    "setPath": string
    "trackPageView": undefined
};

const pushToHsq = <
    TCommand extends keyof CommandsWithParams,
    TCommandParam extends CommandsWithParams[TCommand]
>(command: TCommand, param: TCommandParam) => {
    let _hsq: Array<[TCommand, TCommandParam]> = (window as any)._hsq;

    if (_hsq == null) {
        _hsq = (window as any)._hsq = [];
    }
    
    _hsq.push([command, param]);
}

export const identifyHubspotContact = (email: string, firstname: string, lastname: string) => {
    pushToHsq("identify", { email, firstname, lastname });
    pushToHsq("trackPageView", undefined);
}

export const trackPageView = (pageTitle: string) => {
    const oldTitle = document.title;
    document.title = pageTitle;
    pushToHsq("trackPageView", undefined);
    document.title = oldTitle;
}